// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index-top[data-v-39206ad8]{height:80px;width:100%;background:#ad112a}.index-top__img[data-v-39206ad8]{width:1200px;margin:0 auto;height:80px;background:url(https://cdn.gelonghui.com/static/web/image_newyear_banner%402x.png) 0 0 no-repeat;background-size:100% 100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
